import {getMetaDataByOne, isZyapp,exchangeSession} from "./modulesForApp";

const getRandomStr = () => {
	let timestamp = new Date().getTime();
	let random = Math.random();
	let four;
	if (random > 0.1) {
		four = Math.round(random * 10000);
	} else {
		random += 0.1;
		four = Math.round(random * 10000);
	}
	return "" + timestamp + four;
};
const getTraceId = async userId => {
	let traceIdPre = sessionStorage.getItem("traceIdPre") || "";
	if (!traceIdPre) {
		if (isZyapp()) {
			traceIdPre = await getMetaDataByOne("TRACE_LOGID_PREFIX");
		}
		if (!traceIdPre || JSON.stringify(traceIdPre) === "{}") {
			const FingerprintJS = require("@fingerprintjs/fingerprintjs");
			const fpPromise = FingerprintJS.load();
			const fp = await fpPromise;
			const result = await fp.get();
			const uuid = result.visitorId;
			traceIdPre = uuid.slice(0, 8);
		}
		sessionStorage.setItem("traceIdPre", traceIdPre);
	}
	return userId ? `${traceIdPre}-${userId}-${getRandomStr()}` : `${traceIdPre}-${getRandomStr()}`;
};
const getAxiosConfig = async (userId, config) => {
	let res={};
	const traceId = await getTraceId(userId);
	console.log("traceId===>", traceId);
	config.headers["headerTraceLog"] = traceId;
	const url = config.url;
	config.url = url.includes("?") ? `${url}&traceLogId=${traceId}` : `${url}?traceLogId=${traceId}`;
	return config;
};
// export default getAxiosConfig;
export {getAxiosConfig, getTraceId};
